// Store
import { storeToRefs } from "pinia";
import { useSessionStore } from "@store";

export interface Event {
  name: string;
  data?: any;
  includeMasterUsers?: boolean;
}

export function useTrackingEvents() {
  const sessionStore = useSessionStore();
  const { session } = storeToRefs(sessionStore);

  function amplitude({ name, data, includeMasterUsers }: Event) {
    if (window.amplitude == undefined) return;
    if (!includeMasterUsers && session.value?.isMasterUser) return;

    const eventData = { ...data };
    if (session.value?.isMasterUser) {
      eventData.master_user = session.value?.account.username;
    } else {
      eventData.account_user = session.value?.account.username;
    }

    window.amplitude.getInstance().logEvent(name, eventData);
  }

  function intercom({ name, data }: Event) {
    if (window.Intercom == undefined) return;
    // a intercom nunca mando eventos de master user
    if (session.value?.isMasterUser) return;

    window.Intercom("trackEvent", name, data);

    setTimeout(function () {
      window.Intercom("update");
    }, 1000);
  }

  function dispatchAll(event: Event) {
    amplitude(event);
    intercom(event);
  }

  return {
    amplitude,
    intercom,
    dispatchAll,
  };
}
